export var IFrameStates;

(function (IFrameStates) {
  IFrameStates[IFrameStates["FALSE"] = 0] = "FALSE";
  IFrameStates[IFrameStates["TRUE"] = 1] = "TRUE";
})(IFrameStates || (IFrameStates = {}));

export var PlayerState;

(function (PlayerState) {
  PlayerState[PlayerState["ENDED"] = 0] = "ENDED";
  PlayerState[PlayerState["PLAYING"] = 1] = "PLAYING";
  PlayerState[PlayerState["PAUSED"] = 2] = "PAUSED";
})(PlayerState || (PlayerState = {}));

export var EventTypes;

(function (EventTypes) {
  EventTypes["READY"] = "ready";
  EventTypes["STATE_CHANGE"] = "stateChange";
})(EventTypes || (EventTypes = {}));